var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonQuery',{attrs:{"formTitle":_vm.textObj.formTitle,"infoArray":_vm.infoArray,"isLoading":_vm.isLoading,"hint":_vm.textObj.hint},scopedSlots:_vm._u([{key:"result-content",fn:function(){return [_c('ResultContent',{attrs:{"backgroundColor":_vm.bgColor,"resultArray":_vm.resultArray}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }